import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PropTypes } from "prop-types";

import { gaCustomEvent } from "../../context/helpers";
import { ALLink } from "../ALComponents";
import useDeviceDetect from "../../hooks/useDeviceDetect";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { ComponentType } from "../../constants/ComponentType";

import * as Styles from "./collectionTiles/styles.module.scss";

function CollectionTiles({ content, componentType }) {
  const { isMobile } = useDeviceDetect();

  const additionalClassName = componentType ? `${Styles[componentType.toLowerCase()]}` : "";

  const onClick = (title) => {
    gaCustomEvent("Collection Tiles", "Click", title);
  };

  if (!content) {
    return null;
  }

  return (
    <div className={`id-${content.contentful_id}`}>
      {content.title && (
        <h2 className={`${Styles.title} ${additionalClassName} h2 h2--bold h2--uc`}>
          {content.title}
        </h2>
      )}
      <div className={Styles.tiles_container}>
        {content.tiles.map((tile, i) => {
          const imageLink = tile?.image?.link?.link?.link;
          const isImageClickable = imageLink && imageLink !== "empty" && imageLink !== "null";
          const linkTitle = tile.link?.title;

          const imageElement = (
            <GatsbyImage
              image={
                isMobile
                  ? getImage(tile.image.mobileImage.gatsbyImageData)
                  : getImage(tile.image.desktopImage.gatsbyImageData)
              }
              alt={tile.image.altText}
            />
          );

          const linkElement = (
            <span
              className="subtext subtext--uc subtext--bold underline"
              onClick={() => onClick(linkTitle)}
            >
              {linkTitle}
            </span>
          );

          if (isImageClickable) {
            return (
              <ALLink to={imageLink} className={Styles.tile}>
                {imageElement}
                {linkTitle !== "empty" && linkTitle !== "null" && (
                  <div className={Styles.link}>{linkElement}</div>
                )}{" "}
              </ALLink>
            );
          }
          return (
            <div className={Styles.tile} key={`tile-${i}`}>
              {imageElement}
              {linkTitle !== "empty" && linkTitle !== "null" && (
                <ALLink to={tile.link.link.link} className={Styles.link}>
                  {linkElement}
                </ALLink>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

CollectionTiles.propTypes = {
  content: PropTypes.shape({
    contentful_id: PropTypes.string,
    title: PropTypes.string,
    tiles: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.shape({}),
        link: PropTypes.shape({}),
      })
    ),
  }),
  componentType: PropTypes.oneOf([ComponentType.PDP, ComponentType.HP]),
};

export default withALErrorBoundary({
  name: "CollectionTiles",
  priority: "P2",
})(CollectionTiles);
